export default "__VITE_ASSET__d3516241__"